import { render } from "./CodePage.vue?vue&type=template&id=1f4d1d13&scoped=true"
import script from "./CodePage.vue?vue&type=script&lang=js"
export * from "./CodePage.vue?vue&type=script&lang=js"

import "./CodePage.vue?vue&type=style&index=0&id=1f4d1d13&scoped=true&lang=stylus"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4d1d13"]])

export default __exports__